import Repository from '@/repositories/marketing'
const resource = 'social_leads'

export default {
  fetchSocialLeads(config) {
    return Repository.get(`${resource}.json`, config)
  },
  toggleLeadStatus (leadId, payLoad) {
    return Repository.put(`${resource}/${leadId}.json`, payLoad)
  },
  deleteLead(leadId) {
    return Repository.delete(`${resource}/${leadId}.json`)
  }
}
